export default "__VITE_ASSET__8aGIBQ8Z__"